import React, { useState, useEffect } from "react";
import moment from "moment";
import strings from "../../Utils/strings";
import clinicService from "../../Services/clinicService";
import "../../Components/viewClinicProfile/profile.css";
import authService from "../../Services/authService";
import { useLocation } from "react-router";
import Widgets from "../../Widgets";
import { t } from "../../Utils/translate";
import utils from "../../Utils";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
// import { onMessageListener } from "../../firebase";
function ProfileCard({ doctorInfo, isLangEn }) {
  console.log(isLangEn);
  const state = useLocation();
  const [doctorDetails, setDoctorDetails] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [expInMonth, setExpInMonth] = useState(null);
  const [expInYear, setExpInYear] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const today = new Date();
  let monthCurrentIs = today.getMonth() + 1;
  let yearIs = today.getFullYear();

  useEffect(() => {
    setDoctorDetails(doctorInfo);
  }, []);

  const convertExperience = (experience) => {
    const years = Math.floor(experience);
    const months = Math.round((experience - years) * 12);

    return { years, months };
  };

  const DoctorExperience = ({ workExperience }) => {
    const { years, months } = convertExperience(workExperience);

    return (
      <div>
        {years} {t("year")}
        {years !== 1 ? "" : ""} {months > 0 && `${months} month${months !== 1 ? "" : ""}`}
      </div>
    );
  };
  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="profile-card">
          <div>
            <div className="d-flex align-items-center">
              <div className="profile-card-image-view ">
                {doctorDetails.profilePic === "null" || doctorDetails.profilePic === null ? (
                  <i className="ri-nurse-line profile-clinic-image"></i>
                ) : (
                  <img src={doctorDetails.profilePic ? doctorDetails.profilePic : null} className="profile-clinic-image" alt="" />
                )}
              </div>
              <div className=" profile-card-info-view" style={{flexGrow:"1"}}>
                <div className="mt-2">
                  {isLangEn ? (
                    <div className="profile-card-name-id" data-toggle="tooltip" title={doctorDetails.name?.en}>
                      {doctorDetails.name?.en}
                    </div>
                  ) : (
                    <div className="profile-card-name-id" data-toggle="tooltip" title={doctorDetails.name?.vi}>
                      {doctorDetails.name?.vi}
                    </div>
                  )}

                  <div className="profile-card-small-info">{isLangEn ? doctorDetails.qualification?.en : doctorDetails.qualification?.vi}</div>
                  <div className="profile-card-small-info">
                    {doctorDetails.gender?.en  === "Female" ? t("Female") : t("Male")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div className="d-flex mt-2 ">
            <div className="col-3 proflie-main-heading profile">{t("label_experience")}</div>
            <div className="flex-shrink-1 bd-highlight email proflie-heading ">
              <span className="d-flex ">
                <DoctorExperience workExperience={doctorInfo.workExperience} />
              </span>
            </div>
          </div>

          <div className="d-flex mt-2">
            <div className="col-3  proflie-main-heading profile">{t("label_contact")}</div>
            <div className="proflie-heading text-nowrap flex-grow">
              +{doctorInfo.countryCode} {doctorInfo.phoneNumber}
            </div>
          </div>
          {doctorInfo.employeeID && (
            <div className="d-flex mt-2">
              <div className="col-3  proflie-main-heading profile">{t("employeeIdd")}</div>
              <div className="proflie-heading text-nowrap flex-grow">{doctorInfo.employeeID}</div>
            </div>
          )}

          {(doctorInfo.email !== "" || doctorInfo.email !== undefined) && (
            <div className="d-flex mt-2">
              <div className="col-3 proflie-main-heading profile">{t("labelEmail")}</div>
              <div className="proflie-heading doctor-email flex-grow">{doctorInfo.email}</div>
            </div>
          )}
          <div>
            <hr />
            {doctorInfo.departmentList && doctorInfo.departmentList.length > 0 && (
              <>
                <div className="col-10 proflie-main-heading">{t("labelSpeciality")}</div>
                {doctorInfo.departmentList.map((depart) => {
                  return (
                    <button type="button" className="btn btn-light sm me-1 mt-1 btn-profile ">
                      {isLangEn ? depart.departmentName?.en : depart.departmentName?.vi}
                    </button>
                  );
                })}
              </>
            )}
          </div>
          <hr />
          {/* {console.log(doctorInfo.languages)} */}
          {doctorInfo.languages && doctorInfo.languages.length > 0 && (
            <>
              <div>
                <div className="col-10 proflie-main-heading">{t("labelLanguage")}</div>
                <div className="flex-shrink-1  email mt-2 ">
                  {doctorInfo.languages.map((lang) => {
                    return (
                      <button type="button" className="btn btn-light sm me-1 btn-profile ">
                        {isLangEn ? lang?.name?.en : lang?.name?.vi}
                      </button>
                    );
                  })}
                </div>
              </div>
              <hr />
            </>
          )}
        </div>
      )}
    </>
  );
}

export default ProfileCard;
